import { useNavigate } from "react-router-dom";
import CustomButton from "../customButtom/CustomButton";
import checkFeatures from "./images/check-features.png";

export default function Card({
  title,
  description,
  buttonText,
  features = [],
  price,
  specialOffer,
  selectedBilling = "monthly",
  onBillingToggle = () => {},
  hideButtons = false,
  currentPlan = null,
  planType = null,
}) {
  const navigate = useNavigate();

  const isProTier = title.includes("Pro Tier");

  const getPeriod = () => {
    if (price === "$35") return "";
    return isProTier && selectedBilling === "yearly" ? "/year" : "/month";
  };

  return (
    <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow-2xl">
      <a href="#">
        <h5 className="mb-2 text-2xl font-bold tracking-tight text-custom-pink">
          {title}
        </h5>
      </a>

      <p className="text-custom-blue font-bold text-4xl md:text-6xl my-7">
        {price}
        <span className="text-lg">{getPeriod()}</span>
      </p>

      {/* Show toggle only for Pro Tier, and now BELOW the price */}
      {isProTier && (
        <div className="text-s text-gray-500 mt-2 mb-4 flex gap-2">
          <span
            onClick={(e) => {
              e.stopPropagation();
              onBillingToggle("monthly");
            }}
            className={`cursor-pointer ${
              selectedBilling === "monthly"
                ? "font-semibold text-purple-700"
                : "text-gray-500 font-semibold"
            }`}
          >
            Monthly
          </span>
          <span>|</span>
          <span
            onClick={(e) => {
              e.stopPropagation();
              onBillingToggle("yearly");
            }}
            className={`cursor-pointer ${
              selectedBilling === "yearly"
                ? "font-semibold text-purple-700"
                : "text-gray-500 font-semibold"
            }`}
          >
            Yearly (Save 2 months)
          </span>
        </div>
      )}

      <p className="mb-3 font-normal text-gray-500 text-sm">{description}</p>

      {!hideButtons && (
        <CustomButton
          label={currentPlan === planType ? "Current Plan" : buttonText}
          onClick={() => currentPlan !== planType && navigate("/auth/login")}
          buttonClass={`rounded-xl px-20 py-5 md:py-5 md:px-32 w-full flex justify-center ${
            currentPlan === planType 
              ? "bg-gray-200 text-gray-600 cursor-not-allowed" 
              : "bg-custom-gradient"
          }`}
          disabled={currentPlan === planType}
        />
      )}

      <div className="border-t border-border-gray w-full my-8" />

      <div>
        <p className="text-custom-blue font-bold text-base">Features</p>
        <div className="flex flex-col gap-2 md:gap-6 my-8">
          {features.map((feature, index) => (
            <div key={index} className="flex gap-x-1.5 items-center">
              <img src={checkFeatures} alt="check" className="w-4 h-4" />
              <span className="text-custom-gray text-sm md:text-base font-normal">
                {feature}
              </span>
            </div>
          ))}
        </div>
      </div>

      {specialOffer && (
        <div className="flex justify-end">
          <div className="bg-custom-pink text-white rounded-l-2xl -mx-6 px-4 py-8 mb-4 w-fit">
            <p className="font-bold tracking-wider uppercase text-sm">
              Limited Time Offer
            </p>
            <p className="font-semibold text-xs">
              1 month free Basic Membership for MVP users
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
